import { mapRangeWithFixedBounds } from './math/mapRange'

interface CalculateGooglePovBetweenPositions {
  google: typeof google
  origin: google.maps.LatLng
  target: google.maps.LatLng
  maxDistance?: number
}
export function calculateGooglePovBetweenPositions({
  origin,
  target,
  maxDistance = 30,
  google,
}: CalculateGooglePovBetweenPositions): google.maps.StreetViewPov {
  const calculatedHeading = google.maps.geometry.spherical.computeHeading(origin, target)
  const distance = google.maps.geometry.spherical.computeDistanceBetween(origin, target)
  const calculatedPitch = mapRangeWithFixedBounds(distance, 0, maxDistance, -20, 10)

  return {
    heading: calculatedHeading,
    pitch: calculatedPitch,
  }
}

interface CalculateGoogleReversePositionUsingPov {
  google: typeof google
  origin: google.maps.LatLng
  pov: google.maps.StreetViewPov
  maxDistance?: number
}
interface CalculateGoogleReversePositionUsingPovResult {
  target: google.maps.LatLng
  distance: number
}
export function calculateGoogleReversePositionUsingPov({
  origin,
  pov,
  maxDistance = 30,
  google,
}: CalculateGoogleReversePositionUsingPov): CalculateGoogleReversePositionUsingPovResult {
  const heading = pov.heading || 0
  const pitch = pov.pitch || 0
  const distance = mapRangeWithFixedBounds(pitch, -20, 10, 0, maxDistance)
  const target = google.maps.geometry.spherical.computeOffset(origin, distance, heading)

  return {
    target,
    distance,
  }
}
